import React, { useEffect } from "react";
import { withStyles } from "@material-ui/styles";
import Grid from "@material-ui/core/Grid";
import TextField from "../../../../ui/TextField";
import DataSelect from "../../../../ui/DataSelect";

const initialData = {
    name: "",
    code: "",
    statusId: 0,
    description: ""
};

const quizstates = [
  {id: 0, name: "Неактивный"},
  {id: 1, name: "Активный"}
];

const styles = () => ({
    root: {
        "& .MuiFormLabel-root": {
            whiteSpace: "nowrap"
        }
    },
});

const AddQuizForm = ({ disabled, onFormChange, classes }) => {
    const [data, setData] = React.useState(initialData);

    const {
      name,
      code,
      statusId,
      description
    } = data;

    const onChange = (field, value) => {
        const newState = {
            ...data,
            [field]: value
        };

        setData(newState);
        onFormChange(newState);
    };

    return (
        <div className={classes.root}>
            <TextField
                required
                value={name}
                onChange={e => onChange("name", e.target.value)}
                label="Название"
                disabled={disabled}
            />
            <Grid container spacing={2}>
                <Grid item xs={6}>
                  <TextField
                      required
                      value={code}
                      onChange={e => onChange("code", e.target.value)}
                      label="Код"
                      disabled={disabled}
                  />
                </Grid>
                <Grid item xs={6}>
                    <DataSelect
                        value={statusId}
                        onChange={value => onChange("statusId", value.id)}
                        label="Статус"
                        dataSource={quizstates}
                        disabled={disabled}
                    />
                </Grid>
            </Grid>
            <TextField
              value={description}
              multiline
              onChange={e => onChange("description", e.target.value)}
              label="Описание"
              disabled={disabled}
            />
        </div>
    );
};

export default withStyles(styles)(AddQuizForm);
